export default __webpack_public_path__ + "static/media/process.2e417f89.png";